import { UseToastOptions } from '@chakra-ui/react';

import { routes } from '@/layouts/config/routes';

export const TOKEN_NAME = 'accessToken';
export const FORM_DATE_FORMAT = 'yyyyMMdd';
export const FORM_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss.0';
export const DEFAULT_API_ERROR_MESSAGE = '시스템 오류';

export const MONACO_EDITOR_OPTION = { minimap: { enabled: false }, tabSize: 2 };

export const ALL_LIST_READ_PER_PAGE = 10000;
export const DEFAULT_NUM_OF_PAGINATION = 10;
export const DEFAULT_ROWS_PER_PAGE = 10;

export const PAGINATOR_OUTER_LIMIT = 1;
export const PAGINATOR_INNER_LIMIT = 1;

export const NOT_SELECTED_TOAST_OPTIONS: UseToastOptions = {
  description: '선택된 데이터가 없습니다.',
  status: 'warning',
  duration: 4000,
  isClosable: true,
};

export const MAX_ROWS_PER_PAGE = 200;

export const DEFAULT_INIT_PAGE = routes.MEMBER_LOGIN.build({});

export const USAGE_FACE_ICON_THRESHOLD = {
  normal: 10,
  caution: 0,
};
